import classNames from "classnames";
import { GatsbyImage, IGatsbyImageData } from "gatsby-plugin-image";
import React from "react";

import { IRichTextInformation } from "@bond-london/graphcms-rich-text";
import { useEntryAnimation } from "../hooks/Visibility";
import { LinkInformation, Links } from "./Links";
import { RTF } from "./RTF";

type ImageSize = "SMALL" | "MEDIUM" | "LARGE";

const getImageSizeClasses = (imageSize: ImageSize | undefined | null) => {
  switch (imageSize) {
    case "SMALL":
      return "aspect-w-16 aspect-h-9";
    case "LARGE":
      return "aspect-w-3 aspect-h-4";
    default:
      return "aspect-w-1 aspect-h-1";
  }
};

export const ThumbnailLink: React.FC<{
  title: string;
  tagline?: string | null;
  message?: IRichTextInformation | null;
  image?: IGatsbyImageData | null;
  alt?: string | null;
  links?: Array<LinkInformation>;
  className?: string;
  imageSize?: ImageSize | null;
}> = (props) => {
  const {
    title,
    tagline,
    image,
    alt,
    links,
    message,
    imageSize = "MEDIUM",
  } = props;
  const [sectionRef, animationMode] = useEntryAnimation();
  const linksAreButtons: boolean = links
    ? links.some((link) => link.showLinkAsButton)
    : false;
  return (
    <section
      ref={sectionRef}
      data-component="Thumbnail Link"
      className={classNames(
        "pb-30px",
        "flex",
        "flex-col",
        "w-full",
        animationMode,
        "animate-appear"
      )}
    >
      <span className={classNames("h6 text-hyacinth", "mb-20px")}>
        {tagline}
      </span>
      {title && (
        <h3 className={classNames("h4 mb-20px md:h-100px")}>{title}</h3>
      )}
      {image && (
        <div className={classNames("mb-30px lg:mt-60px", "grid", "w-full")}>
          <GatsbyImage
            objectFit="cover"
            image={image}
            alt={alt ?? ""}
            className={classNames(getImageSizeClasses(imageSize))}
            loading="lazy"
          />
        </div>
      )}
      {message && (
        <RTF
          className="relative col-span-4 col-start-2 row-start-4 mb-20px lg:col-span-5 lg:col-start-10 lg:row-start-3"
          fixedParagraphClassName="p3"
          content={message}
        />
      )}
      {links && (
        <Links
          links={links}
          className={linksAreButtons ? "servicesButton" : ""}
        />
      )}
    </section>
  );
};
